import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function SyncButton({ handler, disabled }) {
  const {
    t,
  } = useTranslation();

  return (
    <div className="float-right">
      <Button onClick={handler} size="md" className="text-primary btn-link edit" title={t("common.labels.synchronizeData")} disabled={disabled}>
        <i className={disabled ? "nc-icon nc-refresh-02 icon-bold fa-spin" : "nc-icon nc-refresh-02 icon-bold"} />
      </Button>
    </div>
  );
}
